import type { StrategyLevel } from '@mnc/contracts';
import { ZOOMS, type Zoom } from './Timeline';

export type StrategyTab = 'overview' | 'cascade' | 'schedule' | 'kpis' | 'topics' | 'sections';
export const STRATEGY_TABS: StrategyTab[] = ['overview', 'cascade', 'schedule', 'kpis', 'topics', 'sections'];
const LEVELS = ['strategy', 'sector', 'objective', 'initiative', 'project', 'sub_project'];

/** URL state of the strategy page: which tab, which node the visual tabs are scoped to, the detail level and zoom. */
export interface StrategySearch {
  tab?: StrategyTab;
  node?: string;
  focus?: StrategyLevel;
  zoom?: Zoom;
}

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined);

export function parseStrategySearch(raw: Record<string, unknown>): StrategySearch {
  const tab = str(raw.tab);
  const focus = str(raw.focus);
  const zoom = str(raw.zoom);
  return {
    tab: tab && (STRATEGY_TABS as string[]).includes(tab) ? (tab as StrategyTab) : undefined,
    node: str(raw.node),
    focus: focus && LEVELS.includes(focus) ? (focus as StrategyLevel) : undefined,
    zoom: zoom && (ZOOMS as string[]).includes(zoom) ? (zoom as Zoom) : undefined,
  };
}
